import { render } from "./VaPageNotFoundCustom.vue?vue&type=template&id=51a2b37c"
import script from "./VaPageNotFoundCustom.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundCustom.vue?vue&type=script&lang=js"

import "./VaPageNotFoundCustom.vue?vue&type=style&index=0&id=51a2b37c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__